import * as angular from 'angular';
import {FulfillmentStepRequestsService} from "./fulfillment-step-requests.service";
import {FulfillmentStepFilterPayloadModel} from "../models/fulfillment-step-filter-payload.model";
import {ThreePlExtraData} from "../../threePL/models/threepl-extra-data.model";
import {CancellationReason} from "../../cancellation-reasons/models/cancellationReason.model";
import {IQService} from "angular";
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";
import {FulfillmentAlertsService} from "./fulfillment-alerts.service";
import {GlobalSearchItemsType} from "../../search/types/global-search-items.type";
import {SuperSearchSortMethodType} from "../../search/types/super-search-sort-method.type";

export class FulfillmentStepService {

  constructor(private bringozLoaderService: BringozLoaderService, private $log, private fulfillmentStepRequestsService: FulfillmentStepRequestsService,
              private fulfillmentAlertsService: FulfillmentAlertsService, private $q: IQService, private globalSearchService) {
  }


  getStepsByQuery(fulfillmentStepFilterPayloadModel: FulfillmentStepFilterPayloadModel) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.fulfillmentStepRequestsService.getStepsByQuery(fulfillmentStepFilterPayloadModel)
      .then((response) => {
        deferred.resolve(response);
      })
      .catch((error) => {
        // this.fulfillmentAlertsService.exportError();
        this.$log.error('Failed to get fulfillment steps by query', error);
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })

    return deferred.promise;
  }

  dispatchConsolidate(containerDetails: ThreePlExtraData, query) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.fulfillmentStepRequestsService.dispatchConsolidate(containerDetails, query)
      .then((response) => {
        deferred.resolve(response);
      })
      .catch((error) => {
        // this.fulfillmentAlertsService.exportError();
        this.$log.error('Failed to get fulfillment steps by query', error);
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })

    return deferred.promise;
  }


  manualHandleAttempt(payload) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.fulfillmentStepRequestsService.manualHandleAttempt(payload)
      .then(res => {
        this.fulfillmentAlertsService.manualHandledAttemptManySuccess();
        deferred.resolve(res);
      })
      .catch((error) => {
        this.fulfillmentAlertsService.manualHandledAttemptManyError();
        this.$log.error('Failed to manually handled fulfillment step attempts', error);
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  // cancelAttempt(ids: string[], cancellationReason: CancellationReason) {
  //   const deferred = this.$q.defer();
  //
  //   this.bringozLoaderService.on();
  //   this.fulfillmentStepRequestsService.cancelAttempt(ids, cancellationReason)
  //     .then(res => {
  //       ids.length > 1 ? this.fulfillmentAlertsService.cancelAttemptManySuccess() : this.fulfillmentAlertsService.cancelAttemptSingleSuccess();
  //       deferred.resolve(res);
  //     })
  //     .catch((error) => {
  //       ids.length > 1 ? this.fulfillmentAlertsService.cancelAttemptManyError() : this.fulfillmentAlertsService.cancelAttemptSingleError();
  //       this.$log.error('Failed to cancel fulfillment step attempts', error);
  //       deferred.reject(error)
  //     })
  //     .finally(() => {
  //       this.bringozLoaderService.off();
  //     });
  //
  //   return deferred.promise
  // }

  cancelAttempt(payload) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.fulfillmentStepRequestsService.cancelAttempt(payload)
      .then(res => {
        this.fulfillmentAlertsService.cancelAttemptManySuccess();
        deferred.resolve(res);
      })
      .catch((error) => {
        this.fulfillmentAlertsService.cancelAttemptManyError()
        this.$log.error('Failed to cancel fulfillment step attempts', error);
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  cancelSteps(ids: string[]) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.fulfillmentStepRequestsService.cancelSteps(ids)
      .then(res => {
        this.fulfillmentAlertsService.cancelStepsSuccess();
        deferred.resolve(res);
      })
      .catch((error) => {
        this.fulfillmentAlertsService.cancelStepsError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  getGlobalSearch(query: string, limit: number = 10, autoComplete: boolean = true, sortMethod?: SuperSearchSortMethodType) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.fulfillmentStepRequestsService.getGlobalSearch(query, limit, autoComplete, sortMethod)
      .then(steps => {
        deferred.resolve(this.globalSearchService.itemToItemOfType(steps, GlobalSearchItemsType.Attempts));
      })
      .catch((error) => {
        this.fulfillmentAlertsService.getGlobalSearchError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  getFulfillmentStepSettings(stepIds: string[]) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.fulfillmentStepRequestsService.getFulfillmentStepSettings(stepIds)
      .then(settings => {
        deferred.resolve(settings);
      })
      .catch((error) => {
        this.fulfillmentAlertsService.getGlobalSearchError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }


}

angular
  .module('bringoz.admin.fulfillment')
  .service('fulfillmentStepService', FulfillmentStepService);
